const React = require('react');
const FormValidationUtils = require('hooks/useFormPrimitives/validation');
const FieldTypeUtils = require('hooks/useFormPrimitives/fieldTypes');
const UserInputsValidationUtils = require('./fieldValidationUtils');
const AgeUtils = require('hooks/useFormPrimitives/ageUtils');
const SelectWithSpecifyUtils = require('hooks/useFormPrimitives/selectWithSpecifyUtils');

const {
    useCallback
} = React;

module.exports = function useUserInputsValidation({
    formConfig,
    getFieldValue,
    inputRefs = {},
    rendererStateRef,
    props
}) {

    const validate13YearsOld = useCallback((date) => {

        return AgeUtils.validateAgeRange({
            birthdate: date
        });
    }, []);

    const validate = useCallback((field) => {

        const definition = formConfig.getFieldDefinition(field);
        const context = {
            field,
            formConfig,
            getFieldValue,
            inputRefs,
            isSignupPage: props.mode === 'signup',
            props,
            rendererState: rendererStateRef.current,
            validateAge: validate13YearsOld
        };

        const value = getFieldValue(field);

        if (FieldTypeUtils.isSelectWithSpecifyType(definition.type)) {
            return SelectWithSpecifyUtils.validate({
                value,
                definition
            });
        }

        return FormValidationUtils.runFieldValidation({
            definition,
            value,
            context,
            validators: UserInputsValidationUtils.validators
        });
    }, [formConfig, getFieldValue, inputRefs, props, rendererStateRef, validate13YearsOld]);

    return {
        validate
    };
};
